<script>
    export default {
        name: 'sliding-dropdown',

        methods: {
            /**
             * Hides or unhides the element referenced with the "items" ref, with a sliding animation.
             */
            toggle() {
                $(this.$refs.items).slideToggle();
            },
        },
    };
</script>

<style lang="less">
    .sliding-dropdown {
        > .sliding-dropdown-items {
            display: none;
        }
    }
</style>
